export default {"src":"/login-app/[GIT_HASH]/_next/static/media/compass.c89b1c29.svg","height":1099,"width":1099,"blurWidth":0,"blurHeight":0};